<div class="stripe-card">
    <nz-spin [nzSpinning]="loading">
        <ng-container *ngIf="val; else creditCardTpl">
            <div
                class="reset-card"
                (click)="reset()"
            >
                Reset Card
            </div>

            <div class="stripe-label">{{'Name of Cardholder'
                }}
            </div>
            <div class="card-placeholder">
                {{val?.card?.name}}</div>
            <div
                style="display: flex;align-items: center;gap: 1rem; justify-content: space-between;margin-top: 1rem;">
                <div style="flex:1">
                    <div class="stripe-label">
                        {{'Card Number'}}
                    </div>
                    <div class="card-placeholder">
                        {{val?.card?.brand}}
                        ****
                        **** ****
                        {{val?.card?.last4}}</div>
                </div>

                <div>
                    <div class="stripe-label">
                        {{'EXP'}}
                    </div>
                    <div class="card-placeholder">
                        {{val?.card?.exp_month}} / {{val?.card?.exp_year}}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #creditCardTpl>
            <!-- <h3 class="stripe-title">Stripe</h3> -->

            <form [formGroup]="FG">
                <div class="stripe-label">{{'Name of Cardholder' }}
                </div>
                <nz-form-item>
                    <nz-form-control
                        nzErrorTip="* Required"
                        style="text-align: left;"
                    >
                        <input
                            class="cardholder-name"
                            style="padding: 9px;"
                            nz-input
                            formControlName="name"
                            placeholder="Jane Doe"
                        >
                    </nz-form-control>
                </nz-form-item>

                <div class="stripe-label">{{'Card Number'}}
                </div>
                <ngx-stripe-card
                    [stripe]="stripe"
                    [options]="cardOptions"
                    [elementsOptions]="elementsOptions"
                ></ngx-stripe-card>
                <p
                    style="text-align: left;color: #ff4d4f"
                    *ngIf="stripeError && !val"
                >{{stripeError}}</p>

            </form>
        </ng-template>
    </nz-spin>
</div>